// extracted by mini-css-extract-plugin
export default {"nepSyllabus":"NEP-Syllabus_nepSyllabus__4ZJzS","syllabusContent":"NEP-Syllabus_syllabusContent__BTHpR","coursesList":"NEP-Syllabus_coursesList__TTAgj"};